/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseCityResponseDto>;
export function request(body: defs.basics.BaseCityRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCity/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
